var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                { class: { "error-input": _vm.$v.data_layer.name.$error } },
                [
                  _c("label", [_vm._v("Name*")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "max-length": 50,
                      placeholder: "Position Layer Name"
                    },
                    model: {
                      value: _vm.$v.data_layer.name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.data_layer.name, "$model", $$v)
                      },
                      expression: "$v.data_layer.name.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                { class: { "error-input": _vm.$v.data_layer.code.$error } },
                [
                  _c("label", [_vm._v("Code*")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: { "max-length": 50, placeholder: "Code" },
                    model: {
                      value: _vm.$v.data_layer.code.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.data_layer.code, "$model", $$v)
                      },
                      expression: "$v.data_layer.code.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                { class: { "error-input": _vm.$v.data_layer.parent.$error } },
                [
                  _c("label", [_vm._v("Parent Layer")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      "is-async": true,
                      "load-options": _vm.loadOptionsParent,
                      placeholder: "Select Parent",
                      "value-format": "object",
                      label: "Parent",
                      "search-prompt-text":
                        "Type minimum 3 characters to search..."
                    },
                    model: {
                      value: _vm.$v.data_layer.parent.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.data_layer.parent, "$model", $$v)
                      },
                      expression: "$v.data_layer.parent.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fe4eb83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fe4eb83","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layer/jLayerForm.vue
// module id = null
// module chunks = 